import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

const BudgetingStructureSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDefault: z.boolean(),
  assignedActivities: z.array(z.string()),
  levels: z.array(z.string()),
});

export const BudgetingStructuresListSchema = createResponseSchema(
  BudgetingStructureSchema,
);
